import classNames from 'classnames';
import React from 'react';
import {
	IChatEventPostbackMessage,
	IChatEventSurveyDataMessage,
	isEventMessageSurveyData,
} from '@enuan/chat__utils';
import { Summary } from './Summary';
import { useMessageContext } from '../../message/message.context';
import { useBlockMessageClassNames } from 'src/hooks/core/messages.hooks';
import { BaseFormMessage } from '../form/BaseFormMessage';
import type { IOptionalMessageProps } from '../../UI/Message/Message';

type ISummaryMessageContent =
	| IChatEventSurveyDataMessage
	| IChatEventPostbackMessage;

export const SummaryMessage = React.forwardRef<
	HTMLElement,
	{ className?: string } & IOptionalMessageProps
>(function SummaryMessage({ className, ...messageProps }, ref) {
	const messageClassName = useBlockMessageClassNames();
	const { message } = useMessageContext<ISummaryMessageContent>();
	const {
		_data: {
			parameters: { metadata },
		},
	} = message;
	const data = isEventMessageSurveyData(message)
		? message._data.parameters.data
		: message._data.parameters.payload;

	return (
		<BaseFormMessage
			{...messageProps}
			ref={ref}
			message={message}
			className={classNames(
				className,
				messageClassName,
				'message--summary',
				'message--form',
			)}
			customHeader={null}
			customAvatar={null}
		>
			<Summary data={data} metadata={metadata} toggable={true} />
		</BaseFormMessage>
	);
});
